import { el, onTap } from './dom.ts';
import { t } from '../i18n/index.ts';

// Araç tarayıcısının ekran klavyesinde boşluk tuşu çıkmayabiliyor; iki kelimelik
// arama yazılamıyordu. Arama kutusunun yanına, yalnız araç yüzeyinde görünen bir
// "Boşluk" düğmesi konur (görünürlük CSS'te: [data-surface="car"] .space-key).

/** İmlecin olduğu yere tek boşluk ekler; klavye açık kalsın diye odağı kutuda tutar. */
export function spaceKey(input: HTMLInputElement): HTMLButtonElement {
  const button = el('button', { class: 'space-key', type: 'button', 'aria-label': t('common.space') },
    el('span', { class: 'space-key-bar', 'aria-hidden': 'true' }), t('common.space')) as HTMLButtonElement;
  // Düğmeye basmak kutunun odağını almasın: odak giderse klavye kapanır.
  const keepFocus = (event: Event) => event.preventDefault();
  button.addEventListener('pointerdown', keepFocus);
  button.addEventListener('mousedown', keepFocus);
  onTap(button, () => {
    const start = input.selectionStart ?? input.value.length;
    const end = input.selectionEnd ?? start;
    // Baştaki ve art arda boşluk aramayı değiştirmez; eklenmez.
    if (start > 0 && input.value[start - 1] !== ' ') {
      input.setRangeText(' ', start, end, 'end');
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }
    input.focus();
  });
  return button;
}

/** Kutuyu ve boşluk düğmesini yan yana tutan satır. */
export function withSpaceKey(input: HTMLInputElement, attrs: Record<string, unknown> = {}): HTMLElement {
  return el('div', { ...attrs, class: ['space-row', attrs.class].filter(Boolean).join(' ') }, input, spaceKey(input));
}
